import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "@/contexts"

interface FeatureGateProps {
  children: ReactNode
}

// Portal rollout gate (UX layer). During limited rollout, a client without full
// access is redirected to the Payment Center if they try to reach a gated page
// directly via URL. The backend enforces this independently (requireFullPortal),
// so this is purely to avoid showing a locked client a dead page. Deal managers
// and full-access clients pass through. Use INSIDE <ProtectedRoute>.
export const FeatureGate = ({ children }: FeatureGateProps) => {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (user?.userType === "client" && user.fullPortalAccess === false) {
    return <Navigate to="/payment" replace />
  }

  return <>{children}</>
}
